import React, { useState, useEffect } from 'react';
import api from '../../../configs/api';
import './css/DiretoriaSection.css';

export default function DiretoriaSection() {
  const [diretoria, setDiretoria] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDiretoria = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/diretoria');
        
        if (response.data && response.data.length > 0) {
          // Filtrar apenas os ativos e limitar para exibição
          const ativos = response.data.filter(item => item.ativo !== false).slice(0, 12);
          setDiretoria(ativos);
        } else {
          setDiretoria([]);
        }
      } catch (error) {
        console.error('Erro ao buscar diretoria:', error);
        setDiretoria([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDiretoria();
  }, []);

  if (loading) {
    return (
      <section className="diretoria-section">
        <div className="diretoria-container">
          <h2 className="section-title">Diretoria</h2>
          <div className="loading-container">
            <p>Carregando...</p>
          </div>
        </div>
      </section>
    );
  }

  if (diretoria.length === 0) {
    return null;
  }

  return (
    <section className="diretoria-section">
      <div className="diretoria-container">
        <h2 className="section-title">Diretoria</h2>
        <div className="diretoria-grid">
          {diretoria.map((membro) => (
            <div key={membro._id} className="diretoria-card">
              {membro.imagem && (
                <div className="diretoria-card-image">
                  <img
                    src={membro.imagem}
                    alt={membro.nome}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
              {membro.logo && (
                <div className="diretoria-card-logo">
                  <img
                    src={membro.logo}
                    alt="Logo"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
              <div className="diretoria-card-content">
                <h3 className="diretoria-card-name">{membro.nome}</h3>
                {membro.cargo && (
                  <p className="diretoria-card-cargo">{membro.cargo}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
